let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eyM85")).then(() => parcelRequire('9Ej9o'));